import React from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './AddMoreCard.module.css';

const AddMoreCard = () => {
  const navigate = useNavigate();
  return (
    <div className={styles.card} onClick={() => navigate('/explore')} style={{ cursor: 'pointer' }}>
      <div className={styles.plus}>+</div>
      <div className={styles.text}>Add More</div>
    </div>
  );
};

export default AddMoreCard; 